import { SearchTerm } from './SearchTerm';

const NotificationSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "name",
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "vruleDisplayType",
        searchOnName: "vruleDisplayType.vrdtName",
        translationKey: "type"
    },
    {
        heading: "Report",
        accessor: "reportName",
        searchOnName: "reportName",
        translationKey: "report"
    },
    {
        heading: "Account",
        accessor: "accountName",
        searchOnName: "accountName",
        translationKey: "account"
    }
];

export default NotificationSearch;
